import script from "./ModalCompose.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCompose.vue?vue&type=script&setup=true&lang=js"

import "./ModalCompose.vue?vue&type=style&index=0&id=532abaf8&lang=css"

const __exports__ = script;

export default __exports__